import { useEffect } from "react";

export const useGoogleAnalyticsHandler = (requestData) => {

    useEffect(() => {
        if (!window.jostensGASY25Enabled) return;

        const scriptId = 'google-analytics-script';

        // Return if the page is not initialized yet with proper parameters
        if(!requestData?.customerNumber) return;

        // Return if GA Script is already injected.
        if(document.querySelector(`#${scriptId}`)) return;

        const googleAnalyticsScriptElement = document.createElement('script');
        googleAnalyticsScriptElement.src = '/apps/jcom/s4/src/js-lib/jostens-ga-tracking/jostens-ga-tracking.js';
        googleAnalyticsScriptElement.setAttribute("data-ot-ignore", "data-ot-ignore");
        googleAnalyticsScriptElement.setAttribute("id", scriptId);

        googleAnalyticsScriptElement.onload = () => {
            initJostensGASY25Engine(requestData.customerNumber)
            pageLoadTrackingGASY25(requestData)
        };
        googleAnalyticsScriptElement.onerror = (error) => {
            console.error('Failed to load GA tracking script:', error);
        };

        document.head.appendChild(googleAnalyticsScriptElement);
    }, [requestData?.customerNumber]);

    function initJostensGASY25Engine(customerNumber) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.init({
                customerId: customerNumber,
                gaPageType: window.jostensGaTracking.gaPageTypeList.schoolStorePage,
                publishedCatalogId: '-',
                publishedProductId: '-',
                sourceCatalogType: '-'
            })
        }
    }

    function pageLoadTrackingGASY25({ customerClassCode, catalogOsrList }) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.schoolStorePage.schoolStorePageLoad,
                client: {
                    _resolveFields: {
                        businessUnit: { catalogOsrList, customerClassCode },
                        productLine: { catalogOsrList }
                    }
                }
            })
        }
    }

    function selectItemTrackingGASY25(catalogOsr, customerClassCode=null, clickText, itemName, actionType) {
        if (typeof window.jostensGaTracking !== "undefined") {
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.schoolStorePage.selectItem,
                client: {
                    _resolveFields: {
                        businessUnit: { catalogOsr, customerClassCode },
                        productLine: { catalogOsr }
                    },
                    clickText, itemName, actionType
                }
            })
        }
    }
    
    return {
        selectItemTrackingGASY25
    }
}